import { useId } from 'react';

import { LinearGradient } from '@visx/gradient';
import { type AxisScale, AreaSeries as VisxAreaSeries } from '@visx/xychart';

import type { BaseAreaSeriesProps } from '@visx/xychart/lib/components/series/private/BaseAreaSeries';

export const AreaSeries = <XScale extends AxisScale, YScale extends AxisScale, Datum extends object>({
  color,
  data,
  dataKey,
  xAccessor,
  yAccessor,
  'data-testid': dataTestId,
}: Pick<BaseAreaSeriesProps<XScale, YScale, Datum>, 'data' | 'dataKey' | 'xAccessor' | 'yAccessor'> & {
  color?: string;
  'data-testid'?: string;
}) => {
  const gradientId = useId();

  return (
    <>
      <LinearGradient id={gradientId} from={color} to={color} fromOpacity={0.6} toOpacity={0.0} />
      <VisxAreaSeries
        data={data}
        dataKey={dataKey}
        xAccessor={xAccessor}
        yAccessor={yAccessor}
        fill={`url(#${gradientId})`}
        lineProps={{ stroke: color }}
        data-testid={dataTestId}
      />
    </>
  );
};
